import { render, staticRenderFns } from "./NavegacaoMobile.vue?vue&type=template&id=613b965e&scoped=true&"
import script from "./NavegacaoMobile.vue?vue&type=script&lang=js&"
export * from "./NavegacaoMobile.vue?vue&type=script&lang=js&"
import style0 from "./NavegacaoMobile.vue?vue&type=style&index=0&id=613b965e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b965e",
  null
  
)

export default component.exports